// utils/upiValidation.js

/**
 * Validate UPI ID
 * @param {string} upiId - UPI ID to validate
 * @returns {object} - Validation result with status and details
 */

const upiRegex = /^[a-zA-Z0-9._-]{2,256}@[a-zA-Z]{2,64}$/;
const mobileRegex = /^[6-9]\d{9}$/;

export const validateUPI = (input) => {
  if (!input || input.trim() === "") {
    return {
      isValid: false,
      message: "UPI ID or mobile number is required",
      type: null,
    };
  }

  const value = input.trim();

  // ✅ Case 1: Mobile number only
  if (mobileRegex.test(value)) {
    return {
      isValid: true,
      message: "Valid mobile number (can be used for UPI)",
      type: "mobile",
      details: {
        mobile: value,
      },
    };
  }

  // ❌ Case 2: Not valid UPI format
  if (!upiRegex.test(value)) {
    return {
      isValid: false,
      message: "Invalid UPI ID. Use: username@bank OR enter mobile number",
      type: null,
    };
  }

  // ✅ Case 3: Valid UPI ID
  const [username, bankHandle] = value.split("@");

  return {
    isValid: true,
    message: "Valid UPI ID",
    type: mobileRegex.test(username) ? "mobile-upi" : "username-upi",
    details: {
      username,
      bankHandle,
    },
  };
};

// Check if UPI is mobile number based
export const isMobileBasedUPI = (upiId) => {
  if (!upiRegex.test(upiId)) return false;
  const [username] = upiId.split("@");
  return /^\d+$/.test(username);
};

// Get only username from UPI
export const getUsernameFromUPI = (upiId) => {
  if (!upiRegex.test(upiId)) return null;
  return upiId.split("@")[0];
};

// Get only bank handle from UPI
export const getBankHandleFromUPI = (upiId) => {
  if (!upiRegex.test(upiId)) return null;
  return upiId.split("@")[1];
};
